<template>
  <v-app>
    <v-main class="auth-layout__main">
      <v-container fluid class="fill-height">
        <v-row justify="center" align="center" class="fill-height" no-gutters>
          <v-col :cols="cols" :sm="sm" :md="md" :lg="lg" :xl="xl">
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
interface Props {
  cols?: string | number
  sm?: string | number
  md?: string | number
  lg?: string | number
  xl?: string | number
}

withDefaults(defineProps<Props>(), {
  cols: 12,
  sm: 10,
  md: 6,
  lg: 5,
  xl: 4,
})
</script>

<style scoped lang="scss" src="./AuthLayout.scss" />
